var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoBanner({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 87,
    viewBox: "0 0 88 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4923_43637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6538 0H7.19231C3.49625 0 0.5 2.99625 0.5 6.69231V40.1538C0.5 43.8499 3.49625 46.8462 7.19231 46.8462H40.6538C44.3499 46.8462 47.3462 43.8499 47.3462 40.1538V6.69231C47.3462 2.99625 44.3499 0 40.6538 0Z",
    fill: "#E1DEDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4778 20.5783L21.9155 15.8602C21.4085 15.5433 20.8259 15.3681 20.2282 15.3527C19.6305 15.3373 19.0397 15.4823 18.517 15.7727C17.9944 16.063 17.5591 16.4881 17.2564 17.0037C16.9537 17.5193 16.7947 18.1065 16.7959 18.7044V28.1406C16.7947 28.7384 16.9537 29.3257 17.2564 29.8413C17.5591 30.3569 17.9944 30.782 18.517 31.0723C19.0397 31.3627 19.6305 31.5077 20.2282 31.4923C20.8259 31.4769 21.4085 31.3017 21.9155 30.9848L29.4778 26.2667C29.9621 25.9666 30.3616 25.5479 30.6387 25.0501C30.9158 24.5524 31.0613 23.9922 31.0613 23.4225C31.0613 22.8528 30.9158 22.2926 30.6387 21.7948C30.3616 21.2971 29.9621 20.8784 29.4778 20.5783Z",
    fill: "#B1A1DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8081 33.4609H40.6542C36.9582 33.4609 33.9619 36.4572 33.9619 40.1532V80.3071C33.9619 84.0032 36.9582 86.9994 40.6542 86.9994H80.8081C84.5041 86.9994 87.5004 84.0032 87.5004 80.3071V40.1532C87.5004 36.4572 84.5041 33.4609 80.8081 33.4609Z",
    fill: "#EDEBEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4398 52.704H51.0937C49.3188 52.704 47.6165 53.4091 46.3615 54.6642C45.1064 55.9192 44.4014 57.6214 44.4014 59.3963C44.4014 61.1712 45.1064 62.8735 46.3615 64.1285C47.6165 65.3836 49.3188 66.0886 51.0937 66.0886H54.4398L74.5168 72.781V46.0117L54.4398 52.704Z",
    fill: "#B1A1DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.964 78.6319C51.2953 78.632 50.6534 78.3686 50.1775 77.8989C49.7015 77.4292 49.4297 76.7909 49.4209 76.1223V66.0838C49.4297 65.4152 49.7015 64.7769 50.1775 64.3072C50.6534 63.8375 51.2953 63.5742 51.964 63.5742C52.6237 63.583 53.2535 63.8513 53.7169 64.321C54.1804 64.7907 54.4402 65.424 54.4401 66.0838V76.1223C54.4402 76.7821 54.1804 77.4154 53.7169 77.8851C53.2535 78.3548 52.6237 78.6231 51.964 78.6319Z",
    fill: "#1B0A4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0937 52.6992H54.4398V66.0838H51.0937C49.3188 66.0838 47.6165 65.3788 46.3615 64.1237C45.1064 62.8687 44.4014 61.1664 44.4014 59.3915C44.4014 57.6166 45.1064 55.9144 46.3615 54.6594C47.6165 53.4043 49.3188 52.6992 51.0937 52.6992Z",
    fill: "#1B0A4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5162 76.9588C73.8564 76.95 73.2267 76.6818 72.7632 76.2121C72.2998 75.7424 72.04 75.1091 72.04 74.4492V44.3338C72.04 43.674 72.2998 43.0407 72.7632 42.571C73.2267 42.1013 73.8564 41.833 74.5162 41.8242C75.1849 41.8242 75.8267 42.0875 76.3027 42.5572C76.7787 43.0269 77.0505 43.6652 77.0593 44.3338V74.4492C77.0505 75.1179 76.7787 75.7561 76.3027 76.2259C75.8267 76.6956 75.1849 76.9589 74.5162 76.9588Z",
    fill: "#1B0A4B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4923_43637"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 87,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoBanner);
export default __webpack_public_path__ + "static/media/no-banner.be718a22d99bdc8756464736fb393249.svg";
export { ForwardRef as ReactComponent };